import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslocoModule } from "@ngneat/transloco";

export type ConfirmationModalTone = "primary" | "warning" | "danger" | "success";

@Component({
  selector: "app-confirmation-modal",
  standalone: true,
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"],
  imports: [CommonModule, TranslocoModule]
})
export class ConfirmationModalComponent {
  constructor(public activeModal: NgbActiveModal) {}

  public title = "";
  public message = "";
  public icon = "";
  public tone: ConfirmationModalTone = "primary";
  public cancelBtnText = "common.controls.cancel";
  public confirmBtnText = "common.controls.confirm";

  confirm() {
    this.activeModal.close(true);
  }

  cancel() {
    this.activeModal.dismiss();
  }
}
